import { authService } from "./authServices";


const blogService = authService.injectEndpoints({
    reducerPath: 'blogService',
    endpoints: (builder) => {
        return {
            getBlogs: builder.query({
                query: () => {
                    return {
                        url: '/blog/get-blogs',
                    };
                },
                providesTags: ['BLOG']
            }),
            getBlogRelative: builder.query({
                query: (id) => {
                    return {
                        url: `/blog/get-blog-relative/${id}`,
                    };
                },
                providesTags: ['BLOG']
            }),
            getBlogAuthor: builder.query({
                query: () => {
                    return {
                        url: '/blog/get-blog-author',
                    };
                },
                providesTags: ['BLOG']
            }),
            getBlogDetail: builder.query({
                query: (id) => {
                    return {
                        url: `/blog/get-blog-detail/${id}`,
                    };
                },
            }),
            getViewsBlog: builder.query({
                query: (id) => {
                    return {
                        url: `/blog/get-views-blog/${id}`,
                    };
                },
            }),
            deleteBlog: builder.mutation({
                query: (id) => {
                    return {
                        url: `/blog/delete-blog`,
                        method: 'DELETE',
                        body: id
                    };
                },
                invalidatesTags: ['BLOG']
            }),
            createBlog: builder.mutation({
                query: data => {
                    return {
                        url: '/blog/create-blog',
                        method: 'POST',
                        body: data
                    };
                },
                invalidatesTags: ['BLOG']
            })
        };

    }
});

export const { useCreateBlogMutation, useDeleteBlogMutation, useGetBlogsQuery, useGetBlogDetailQuery, useGetBlogRelativeQuery, useGetBlogAuthorQuery, useGetViewsBlogQuery } = blogService;

export default blogService;